module.exports = __webpack_public_path__ + "static/media/boy.39fed611.webp";